import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Camera, CheckCircle2, FileText, Folder, PartyPopper, Sparkles, Briefcase } from "lucide-react";
import { api } from "../lib/api";
import { invalidateEntitlements } from "../lib/entitlements";

/**
 * One-time onboarding modal shown right after registration.
 * Auto-starts the 7-day trial in the background so the user lands with everything unlocked.
 */
export default function WelcomeModal({ userName = "", onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Fire-and-forget: activate trial in the background so it's live when they hit "Comenzar".
    api.post("/subscription/start-trial", {}, { withCredentials: true })
      .then(() => invalidateEntitlements())
      .catch(() => {});
  }, []);

  const first = (userName || "").trim().split(" ")[0];

  const handleContinue = () => {
    onClose && onClose();
    navigate("/");
  };

  return (
    <div className="welcome-modal-overlay" data-testid="welcome-modal">
      <div className="welcome-modal" role="dialog" aria-labelledby="welcome-title">
        <div className="welcome-modal-illustration"><PartyPopper size={44} /></div>
        <h1 id="welcome-title">
          🎉 ¡Bienvenido{first ? `, ${first}` : ""} a Mi Contador!
        </h1>
        <p className="welcome-lede">
          Nos alegra mucho tenerte aquí. Tienes <b>7 días completamente gratis</b> para explorar todas las funciones de Mi Contador sin ninguna limitación.
        </p>
        <ul>
          <li><FileText size={16} color="#4169e1" /> Crear facturas CFDI 4.0</li>
          <li><CheckCircle2 size={16} color="#10b981" /> Registrar ingresos y egresos</li>
          <li><Camera size={16} color="#f59e0b" /> Escanear tickets con IA</li>
          <li><Folder size={16} color="#a855f7" /> Organizar documentos</li>
          <li><Briefcase size={16} color="#0ea5e9" /> Administrar proyectos</li>
          <li><Sparkles size={16} color="#ec4899" /> Explorar cada herramienta</li>
        </ul>
        <p className="welcome-footer-text">
          Al finalizar tu periodo de prueba podrás elegir el plan que mejor se adapte a tu negocio. <b>No perderás tu información.</b>
        </p>
        <button className="welcome-modal-cta" onClick={handleContinue} data-testid="welcome-modal-cta">
          Comenzar <Sparkles size={16} />
        </button>
      </div>
    </div>
  );
}
